import { render, staticRenderFns } from "./leastsquares.vue?vue&type=template&id=5ddf5f68&"
import script from "./leastsquares.vue?vue&type=script&lang=js&"
export * from "./leastsquares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports